module.exports = __webpack_public_path__ + "img/bg@3x.daf3f935.png";